
import { Vue, Component } from 'vue-property-decorator';
import Api from '@/services/api';

@Component
export default class NotificationSetting extends Vue {
  public formTitle = 'تنظیمات اطلاع رسانی';
  public editedItem = {
    emailNotify: true,
    phoneNotify: true
  };
  public breadcrumbItems = [
    {
      text: 'صفحه اصلی',
      disabled: false,
      href: '/'
    },
    {
      text: 'تنظیمات اطلاع رسانی',
      disabled: true,
      href: ''
    }
  ];

  async created() {
    await this.initialize();
  }

  async initialize() {
    this.$showLoading();
    await Api.getUserNotificationStatus().then((response) => {
      this.editedItem = response.data;
      this.$hideLoading();
    });
  }

  async editPhoneNotify() {
    this.$showLoading();
    await Api.editPhoneNotification(this.editedItem.phoneNotify).then((response) => {
      this.$showNotification('success', 'بروز رسانی پیامک انجام شد.');
      this.$hideLoading();
    });
  }

  async editEmailNotify() {
    this.$showLoading();
    await Api.editEmailNotification(this.editedItem.emailNotify).then((response) => {
      this.$showNotification('success', 'بروز رسانی ایمیل انجام شد.');
      this.$hideLoading();
    });
  }
}
